import React from 'react';
import { Chip } from '@mui/material';
import { EM_DASH } from './historyFormatters';

/**
 * LaneChip — renders a tracking-status lane name as a chip. Shared by the
 * status-history and weekly-snapshots tables. `highlight` gives the current
 * (most recent) status a distinct accent color.
 */
function LaneChip({ name, highlight = false }) {
  if (!name) return <span>{EM_DASH}</span>;
  return (
    <Chip
      label={name}
      size="small"
      sx={{
        height: 22,
        fontSize: '0.72rem',
        fontWeight: highlight ? 600 : 500,
        bgcolor: highlight
          ? 'var(--phm-accent-bg)'
          : 'var(--phm-surface-strong)',
        color: highlight ? 'var(--phm-accent-text)' : 'var(--phm-text-header)',
        border: highlight
          ? '1px solid var(--phm-accent-border)'
          : '1px solid var(--phm-border)',
      }}
    />
  );
}

export default LaneChip;
